import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getPasswordToken } from "../../configs/auth";
import ReCAPTCHA from "react-google-recaptcha";
import { captchaSiteKey } from "../../configs/auth";
import toast from "react-hot-toast";

function ForgotPassword() {

    const [ email, setEmail ] = useState('');
    const reCaptchaRef = useRef();
    
    const getToken = async (e) => {
        e.preventDefault();
        try{
            const token = await reCaptchaRef.current.executeAsync();
            if(email != '' && token){
                getPasswordToken(email, token);
                reCaptchaRef.current.reset();
            }
           else {
            toast.error('Adj meg email címet!');
           };
            
        } catch (error) {
            console.error(error);
        }
    };
   

    return (
        <div className="container-fluid d-flex justify-content-center align-items-center p-0">
            <div className='col-lg-5 col-md-9 col-11 my-5 p-4 d-flex flex-column justify-content-center align-items-center border shadow'>

                <h4 className="mb-4">Elfelejtett jelszó</h4>

                <form className='d-flex flex-column align-items-center col-lg-7 col-10'>

                    <div className="form-floating">

                        <input type="email" className={`form-control`} id="email" placeholder="" value={email} onChange={(e)=>setEmail(e.target.value)} required/>

                        <label htmlFor="email">Email cím</label>

                    </div>

                    <ReCAPTCHA
                        sitekey={captchaSiteKey}
                        size="invisible"
                        ref={reCaptchaRef}
                    />

                    <div className="col-12 d-flex justify-content-center">
                        <button className='btn btn-home-primary my-3' onClick={(e)=>getToken(e)}>Küldés</button>
                    </div>
                    
                    
                </form>
                

                <div className='d-flex flex-row'>
                    <h6 className='m-0 me-2'>Nincs még fiókod?</h6>
                    <Link to='/registration'>Itt tudsz regisztrálni</Link>
                </div>
            </div>
        </div>

    );
}

export default ForgotPassword;